/** @format */

import React, { useCallback } from "react";
import { InputText } from "primereact/inputtext";
import service from "../../utils/service";
import "../../style/channel.css";
import moment from "moment";
import AccordionLoader from "../common/AccordionLoader";
import useGetRegions from "../../hooks/useRegions";
import {filterDataOnRoles, getRowsPerPage} from "./utils/utils";
import SubscriptionTable from "./common/SubscriptionTable";

function Subscription(props) {
  const [searchText, setSearchText] = React.useState("");
  const [subscriptionData, setSubscriptionData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const { isEdibleOilsRole, isCocoaRole, isAnimalFeedRole, isSuperAdminRole, isGrainsRole, isCornRole } = props;
  const ROWS_PER_PAGE_CONST = 10;
  const regionsData = useGetRegions()
  const getSubscriptions = useCallback(() => {
    return service.getRejectedSubscriptions().then((response) => {
      let data = isSuperAdminRole
        ? response.data
        : filterDataOnRoles(response.data, isEdibleOilsRole, isCocoaRole, isAnimalFeedRole, isGrainsRole, isCornRole);
      setSubscriptionData(data);
    });
  }, [isSuperAdminRole, isEdibleOilsRole, isCocoaRole, isAnimalFeedRole, isGrainsRole, isCornRole]);

  React.useEffect(() => {
    setSubscriptionData([]);
    setLoading(true);
    getSubscriptions()
      .then(() => {
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [getSubscriptions]);

  const searchSubscription = (str) => {
    str = str.toLowerCase();
    return subscriptionData.filter((data) => data.user.toLowerCase().includes(str));
  };
  const columns = [
    {
      field: "requestedDate",
      header: "Requested Date",
      body: (data) => moment(data.requestedDate).format("MMM Do YYYY"),
    },
    { field: "user", header: "User" },
    { field: "email", header: "Email" },
    { field: "channel", header: "Channel" },
    { field: "region", header: "Region" },
    { field: "status", header: "Status", body: (data) => <span style={{ color: "#A22B2F" }}>{data.status}</span> },
    { field: "status", header: "Reason", body: (data) => <span style={{ color: "#A22B2F" }}>{data.rejectedReason}</span> },
  ];
  var subsData = searchSubscription(searchText);

  return (
    <div style={{ marginTop: "1rem" }}>
      <div style={{ marginTop: "1rem", color: "#cccccc" }}>
        <div className='p-fluid formgrid grid'>
          <div className='field col-12 md:col-2'>
            <label htmlFor='searchUser'>Search user</label>
            <InputText
              id='searchUser'
              value={searchText}
              onChange={(event) => setSearchText(event.target.value)}
              type='text'
            />
          </div>
        </div>
        {(loading || regionsData.isLoading) && <AccordionLoader />}
        {!loading && <SubscriptionTable 
          data={subsData}
          rows={ROWS_PER_PAGE_CONST}
          rowsPerPageOptions={getRowsPerPage(subsData, ROWS_PER_PAGE_CONST)}
          columns={columns}
        />}
        </div>
      </div>
  );
}

export default Subscription;
